export enum LocalStorageKeys {
  jwt = 'scholarship-jwt',
  HAVE_SET_LANGUAGE = 'have-set-language',
}

export enum HttpStatusCode {
  Success = 200,
  Unauthorized = 401,
}
